module.exports = __webpack_public_path__ + "static/media/loading.8c98da9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/old/loading.png
// module id = 573
// module chunks = 0